import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const headerStyle = {
    height: '70px',
    overflow: 'visible',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    transition: 'background-color 0.3s ease'
  };

  const navStyle = {
    height: '70px',
    minHeight: '70px',
    maxHeight: '70px',
    backgroundColor: scrolled ? 'rgba(17, 17, 17, 0.95)' : 'transparent',
    transition: 'background-color 0.3s ease',
    boxShadow: scrolled ? '0px 2px 10px rgba(0, 0, 0, 0.1)' : 'none'
  };

  const containerStyle = {
    height: '70px',
    alignItems: 'center'
  };

  const logoContainerStyle = {
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible'
  };

  const logoLinkStyle = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible'
  };

  const logoImgStyle = {
    maxHeight: '40px',
    width: 'auto',
    objectFit: 'contain'
  };

  return (
    <header id="header" className="sticky-top-slide" style={headerStyle}>
      <nav className={`primary-menu navbar navbar-expand-lg navbar-text-light border-bottom-0 text-3 ${scrolled ? 'sticky-on' : ''}`} style={navStyle}>
        <div className="container-fluid position-relative" style={containerStyle}>
          <div className="col-auto col-lg-2" style={logoContainerStyle}>
            <Link className="logo" to="/" title="RovoAutomation" style={logoLinkStyle}>
              <img src="/images/Auto-logo.png" alt="RovoAutomation" style={logoImgStyle} />
            </Link>
          </div>
          <div className="col col-lg-8 navbar-accordion px-0">
            <button className="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#header-nav">
              <span></span><span></span><span></span>
            </button>
            <div id="header-nav" className="collapse navbar-collapse justify-content-center">
              <ul className="navbar-nav">
                {isHomePage ? (
                  <>
                    {/* HOME PAGE LINKS:
                        1. Local section links (e.g., #home) use <a> and smooth-scroll.
                        2. Cross-page links (e.g., /about) MUST use <Link> and NOT smooth-scroll.
                    */}
                    <li className="nav-item">
                      <a className="nav-link smooth-scroll active" href="#home">Home</a>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about">About</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/product">Product</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/solutions">Solutions</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact">Contact</Link>
                    </li>
                  </>
                ) : (
                  <>
                    {/* OTHER PAGES: All links use <Link> for routing, no smooth-scroll. */}
                    <li className="nav-item">
                      <Link className="nav-link" to="/">Home</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about">About</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/product">Product</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/solutions">Solutions</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact">Contact</Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
          <div className="col-auto col-lg-2 d-flex justify-content-end pl-0">
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;